export const ChatChooseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={288}
    height={193}
    viewBox="0 0 288 193"
    fill="none"
  >
    <path fill="#F2F2F2" d="m145.824 128.3-.011 11.711-8.994-13.653z" />
    <path
      fill="#F2F2F2"
      d="M93.503 126.991s-.773-57.53-.219-57.536c.555-.005 51.756.383 51.756.383l.785 58.462z"
    />
    <path
      fill="#64B9FF"
      d="m141.562 112.833-9.16-.165-14.499-.26-13.55-.245-6.828-.122s-.582-37.916-.107-37.922c.245 0 12.376.054 23.776.101 10.184.048 19.781.085 19.781.085z"
    />
    <path
      fill="#fff"
      d="M132.408 112.668c1.846-2.191 4.748-6.036 3.98-7.712-1.451-3.169-4.22-.34-8.45-1.547-3.361-.963-5.121-4.665-5.372-9.356-3.147.128-5.02-.5-6.892-3.02 3.809-4.021 6.076-6.798 6.428-9.76.395-3.35 1.286-6.696 1.755-7.106 10.184.048 17.119.133 17.119.133l.587 38.533z"
    />
    <path
      fill="#006CED"
      d="M134.969 77.73c.405-.452 1.296-.116 1.248.506-.192 2.6 1.12 5.276 3.265 6.77a5.6 5.6 0 0 0 1.669.814l-.176-11.52s-7.303-.026-15.923-.069c.373 4.01 6.999 6.77 9.917 3.5z"
    />
    <path
      stroke="#006CED"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.534}
      d="M130.455 99.537c2.545-.755 4.63-2.883 5.329-5.436"
    />
    <path
      fill="#fff"
      d="m117.903 112.402-13.55-.244c-3.366-7.967-7.719-23.205-4.678-19.71 1.168 2.35 2.054 3.765 3.227 6.116-2.752-7.372-3.11-10.898-.741-8.824 1.536 3.627 1.654 4.16 3.19 7.786-1.926-6.164-1.792-12.014-.059-8.084 2.177 4.936 5.559 12.85 6.637 11.876 1.381-2.281.677-1.053 2.112-4.19 1.323-2.548 2.545-1.027 2.15 3.169-.304 3.293-.144 7.771 1.712 12.105"
    />
    <path
      stroke="#006CED"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.534}
      d="M110.526 101.739c-.923.899-1.243 2.361-.784 3.563m20.517-21.019c0-.415 0-.84.144-1.228.144-.389.469-.74.885-.788.416-.053.822.213 1.057.564.234.346.33.766.426 1.176m-8.525 33.586c5.436.123 10.877.241 16.313.364m-37.976-19.803c.32.548.646 1.096.966 1.644m.559-6.085c.63 1.92 1.259 3.845 1.884 5.765m18.777 21.87c2.507.065 5.014.123 7.521.187"
    />
    <path
      fill="#F2F2F2"
      d="m147.536 74.864-.773-27.38c-.022-2.957 2.379-5.372 5.35-5.372h48.993c3.126 0 5.585 2.665 5.329 5.771l-.645 7.83a5.34 5.34 0 0 1-5.329 4.892h-48.492l-4.433 14.26z"
    />
    <path
      fill="#fff"
      d="M183.865 49.66c-1.355-2.702-3.942-1.825-4.006-.117s4.129 6.547 4.129 6.547 2.513-3.527 3.356-5.58c.736-1.797-1.361-4.042-3.479-.85"
    />
    <path
      fill="#006CED"
      d="M171.483 49.66c-1.355-2.702-3.943-1.825-4.007-.117-.069 1.712 4.129 6.547 4.129 6.547s2.513-3.527 3.356-5.58c.731-1.797-1.36-4.042-3.478-.85m-12.381 0c-1.355-2.702-3.943-1.825-4.007-.117-.064 1.712 4.129 6.547 4.129 6.547s2.513-3.527 3.356-5.58c.731-1.797-1.36-4.042-3.478-.85"
    />
    <path
      fill="#F2F2F2"
      d="m145.825 154.595-6.829.005-39.705.032-.01.25-5.549-.075.006-.175.299-9.324h51.585z"
    />
    <path
      fill="#B0DFFF"
      d="m138.996 154.6-39.705.032.155-4.867h39.444zm25.627-116.684.48-33.32 24.811.196c2.897.021 5.223 2.383 5.191 5.27l-.192 19.467-25.489-.479z"
    />
    <path
      fill="#FF391F"
      d="M179.229 13.743c-2.56-5.1-7.441-3.452-7.569-.218s7.794 12.36 7.794 12.36 4.742-6.659 6.332-10.53c1.392-3.399-2.561-7.638-6.557-1.612"
    />
    <path
      fill="#020202"
      d="m74.213 142.958 16.665-26.077h21.274l-15.657 25.284z"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.534}
      d="M95.781 125.826c1.115-1.165 3.121-1.345 4.423-.388 1.301.952 1.739 2.909.96 4.324s-2.673 2.095-4.177 1.505"
    />
    <path
      fill="#B0DFFF"
      d="M75.915 106.812c11.752-9.706 20.11 2.373 19.225 3.771-.859 1.351-1.125 2.739-1.84 2.596-.432.212 1.45 3.095.683 3.228-1.083.181-2.486-2.218-3.398-4.191 0 0-1.185 1.463-3.847-.686-2.71-2.186-11.069 7.233-23.12 18.498L62.36 118.21c.006.005 9.384-7.946 13.556-11.398z"
    />
    <path
      stroke="#FF391F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.534}
      d="M87.182 109.067a7 7 0 0 1 3.264 2.564m1.621-2.042 1.105 3.255m.085-4.106a3.3 3.3 0 0 1 .901 2.627"
    />
    <path
      fill="#006CED"
      d="M35.206 154.765h36.42c-1.836-8.366-5.8-25.96-9.603-40.07 3.921-4.165-5.308-18.222-7.041-20.216-4.913-5.66-13.145-4.68-13.145-4.68-2.747 1.388-12.536 10.573-9.346 39.591 1.425 12.929 2.24 20.716 2.715 25.375"
    />
    <path
      stroke="#64B9FF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.534}
      d="M51.978 117.742a6.92 6.92 0 0 0 3.81-4.127"
    />
    <path
      fill="#B0DFFF"
      d="M63.117 60.435c-1.168-.83-2.507-1.043-4.022-.543-1.68.553-3.105 1.665-4.535 2.66-1.685 1.175-3.387 2.319-5.153 3.377-1.798 1.08-3.66 2.058-5.596 2.872q-1.008.421-2.048.771c.213 2.51 1.184 5.414 2.88 9.345 3.516 8.132-2.037 10.355-2.811 10.87 0 0 1.296 4.213 6.204 7.457 4.422 2.926 7.468.08 6.94-2.776-3.984-6.127-1.35-8.43 4.978-10.424 8.492-2.675 9.287-15.961 3.163-23.61z"
    />
    <path
      fill="#020202"
      d="M65.058 63.493c-.89-1.782-2.064-3.414-3.526-4.765-.96-.888-2.438-1.495-4.15-1.782.064 1 .304 1.979.752 2.893 1.974 1.835 4.364 3.202 6.924 3.654"
    />
    <path
      fill="#020202"
      d="M45.401 81.15c1.67-.861 3.942-2.61 3.137-4.563-4.23 1.293-6.877-4.116-2.982-6.042.437-.218 2.16-.606 3.9-1.701 3.792-2.389 8.95-6.452 10.087-7.622.768-.787 1.414-1.702 1.739-2.707-3.745-3.01-13.747-2.404-17.481 3.547-3.11 4.957-2.641 8.696.848 16.86.341.803.587 1.543.752 2.229z"
    />
    <path
      fill="#020202"
      d="M44.43 57.393c-3.467-1.165-7.56-.713-10.402 1.585-4.759 3.845-4.833 11.27-8.957 15.785-2.065 2.26-4.956 3.569-7.81 4.686s-5.81 2.133-8.253 3.978-4.337 4.739-4.08 7.786c.224 2.708 2.144 5.085 4.55 6.367s5.228 1.58 7.943 1.398c6.898-.457 13.529-4.004 17.721-9.482 4.194-5.479 5.88-12.792 4.503-19.546-.368-1.803-.944-3.638-.63-5.452.315-1.813 1.932-3.584 3.75-3.276 2.487.426 4.786 7.558 7.096 3.473 2.107-3.718-2.47-6.308-5.431-7.302"
    />
    <path
      stroke="#020202"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.534}
      d="M63.047 68.998c-.773 2.02-.277 4.462 1.233 6.02-1.537 0-3.068-.005-4.604-.005m-2.273-6.148c-.192.415-.379.83-.571 1.239m-.159 6.68c.037 1.814 1.654 3.452 3.473 3.521"
    />
    <path
      fill="#B0DFFF"
      d="M87.805 130.56c1.504-.585 2.982-1.367 4.396-2.165.256-.144 2.502-1.399 1.36-1.654-1.926-.431-4.38 1.383-7.325 2.09-2.944.708-3.366-2.074-2.09-3.499 1.274-1.426 3.413-4.537-.609-2.234-1.824 1.042-2.166 3.893-5.068 5.547-8.3 4.734-20.911 10.978-20.911 10.978l-10.019-24.865q-5.712 1.733-11.41 3.521c1.435 4.101 3.28 9.042 5.404 13.961 7.868 18.243 11.496 21.03 14.894 19.482 7.308-3.334 12.92-7.616 21.781-12.419 8.162-4.425 11.037-4.515 13.294-5.744 2.736-1.494 2.416-2.281 2.592-3.909.144-1.377-5.323.979-5.27.394 0 0 .213-.091.555-.245"
    />
    <path
      stroke="#FF391F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.534}
      d="M89.165 132.549a12.1 12.1 0 0 0 4.993-1.989m-6.632.09c.94-.33 1.878-.665 2.817-.995"
    />
    <path
      stroke="#64B9FF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.534}
      d="M46.21 104.728c1.004 3.191 2.007 6.387 3.01 9.578"
    />
    <path
      fill="#006CED"
      d="m107.299 62.062.426-41.123-31.1-.309c-3.297-.031-5.986 2.633-5.97 5.925l.134 25.806h32.903z"
    />
    <path
      fill="#B0DFFF"
      d="M77.692 28.65c13.49-1.754 13.784-15.79 17.598-14.62s-2.934 14.328-2.934 14.328 10.851-.292 12.318 1.755c1.467 2.048-.88 3.803-.88 3.803s3.227 2.633-.881 5.85c0 0 .881 3.218-2.934 4.974-3.814 1.755-26.694.877-26.694.877z"
    />
    <path
      stroke="#FF391F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.534}
      d="M95.089 30.012c-.742.144-1.51.293-2.134.718-.624.426-1.072 1.208-.87 1.936.14.495.55.883 1.02 1.101.469.218.986.298 1.504.357 2.422.282 4.88.234 7.287-.139m-9.256.92c-.742.234-1.51.474-2.113.968-.603.495-1.019 1.298-.816 2.048.165.622.72 1.085 1.323 1.314.603.228 1.264.26 1.91.292l9.757.447m-11.555.989c-.544.272-1.099.559-1.478 1.032-.379.474-.528 1.186-.176 1.68.395.565 1.2.607 1.889.602 2.198-.032 4.39-.064 6.588-.09m-13.935-4.596a9.53 9.53 0 0 0 4.764-3.34 9.5 9.5 0 0 0 1.9-5.489"
    />
    <path
      fill="#FF391F"
      d="M157.231 131.794c-.678 6.159 1.493 12.43 5.227 17.381s8.93 8.664 14.516 11.387c2.512 1.223 5.169 2.277 7.964 2.5s5.751-.468 7.81-2.356c2.15-1.973 3.067-5.026 3.009-7.941s-.992-5.739-2.049-8.456a87.5 87.5 0 0 0-8.631-16.658c-1.968-2.968-4.182-5.877-7.17-7.813-3.414-2.213-9.613-3.516-13.229-1.112-4.257 2.819-6.898 8.111-7.447 13.068"
    />
    <path
      fill="#B0DFFF"
      d="m171.692 118.817-10.018-16.647-10.611 6.35s4.652 8.701 10.072 18.424c3.505-2.724 7.02-5.436 10.557-8.127"
    />
    <path
      fill="#FF391F"
      d="M194.145 112.748c-2.545 11.217-7.639 30.683-7.639 30.683l-9.779-16.254c-3.227 3.468-6.487 6.914-9.453 10.595 3.014 5.201 5.82 9.845 7.773 12.642 6.791 9.733 8.701 13.967 16.553 11.85s16.132-40.208 16.132-40.208l.597-29.348c-6.545 3.75-11.634 8.829-14.184 20.04"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.534}
      d="M188.843 134.544c.875 2.138 1.749 4.27 2.619 6.409"
    />
    <path
      fill="#020202"
      d="m155.048 80.704-11.96.558 15.07 26.965 12.158-.473c2.123-.085 3.398-2.388 2.336-4.223l-11.171-19.322a7.05 7.05 0 0 0-6.433-3.505"
    />
    <path
      stroke="#B0DFFF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.534}
      d="M160.004 84.3c3.697 6.041 6.898 12.322 10.594 18.364"
    />
    <path
      fill="#FF391F"
      d="m202.962 122.96-3.718 40.517 51.047-.07-3.756-49.515-15.006-25.646-23.205 4.467z"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.534}
      d="M203.362 108.233c-.827 13.11-1.648 26.22-2.475 39.331"
    />
    <path
      stroke="#64B9FF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.534}
      d="M195.483 163.461h45.088"
    />
    <path
      fill="#FF391F"
      d="M231.53 88.246c14.19 4.61 16.527 7.148 28.199 21.54s19.316 24.337 16.345 41.899-17.407 21.163-28.652 16.504c-11.251-4.654-5.132-13.786.171-20.556a408 408 0 0 1 10.365-12.653l-25.606-29.428z"
    />
    <path
      fill="#B0DFFF"
      d="m247.738 173.55 4.833-4.978c-3.164-2.936-6.434-5.755-9.667-8.616l-5.11 6.366c2.027 3.526 6.172 5.803 9.944 7.228"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.534}
      d="M241.015 114.902c2.608 3.043 5.222 6.085 7.831 9.127m.053 22.423c-2.347 1.782-4.753 3.627-6.23 6.175s-1.798 5.994.021 8.308"
    />
    <path
      fill="#B0DFFF"
      d="M151.057 108.52c-4.246-6.771-4.667-16.504-.848-22.008 3.82-5.5 2.758-.633 1.91 3.595l-.848 4.233s2.123-2.116 6.156-1.69c4.033.425 2.336 2.536 2.336 2.536s2.689 3 .635 3.388c-5.633 1.058-1.696 12.695-1.696 12.695z"
    />
    <path
      stroke="#64B9FF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.534}
      d="M159.273 95.76c-1.035-.792-2.572-.734-3.681-.048-1.11.686-1.814 1.904-2.107 3.17-.294 1.271-.214 2.596-.032 3.883m-2.876-7.909a4.41 4.41 0 0 0-1.478 4.016m9.255 10.243c1.329.41 2.369 1.622 2.566 2.995"
    />
    <path
      fill="#B0DFFF"
      d="M222.366 77.071c-1.126-4.84 1.072-9.307 1.579-14.897-.704-.25-1.387-.58-1.969-1.032-1.461-1.138-1.68-3.074-2.048-4.765-.341-1.585-.966-2.973-2.267-3.984-1.291-1.005-2.609-1.915-3.75-3.106-1.126-1.175-2.07-2.574-3.388-3.553-1.627-1.212-3.467-1.35-5.425-1.063-2.177.324-4.273.68-6.482.478a19.4 19.4 0 0 1-3.376-.627 11.7 11.7 0 0 0-1.958 3.462c-3.905 10.887-.48 10.047-6.556 16.62l7.079 1.953s-.102 10.12 8.583 9.977c8.685-.138 10.45 12.116 5.937 16.174 0 0 3.265 5.739 9.768 5.17 7.266-.639 13.438-9.638 13.438-9.638s-7.271-3.037-9.165-11.169"
    />
    <path
      fill="#006CED"
      d="M205.306 77.927c2.225-.558 4.641-1.723 5.948-4.047 1.457-2.58.464-5.983 2.406-8.36 3.11-3.804 6.236.015 9.442 1.696 1.078-5.032 2.059-10.707-2.075-18.535-6.753-12.802-23.115-11.153-27.42-1.527 3.772 1.308 9.016.378 12.574.505.672.027 1.382.468 1.531 1.16 1.014 4.728 1.046 11.02-.944 15.503-.96 2.165-2.737 3.441-5.153 3.43-2.39-.01-5.404-1.78-7.821-1.201.123 2.122.176 12.716 11.512 11.376"
    />
    <path
      fill="#B0DFFF"
      d="m212.124 53.914.411 8.781s6.593-.441 6.412-5c-.16-4.105-5.207-4.286-6.823-3.78z"
    />
    <path
      stroke="#020202"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.534}
      d="M194.994 53.329c-.891 2.186-.555 4.866 1.003 6.637s4.332 2.431 6.444 1.383c2.113-1.053 3.249-3.824 2.299-5.983m-13.602.494 2.736.496"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.534}
      d="M201.716 71.481a7.95 7.95 0 0 0 3.729-2.292c.789.835.645 2.361-.294 3.032"
    />
    <path
      stroke="#020202"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.534}
      d="M199.651 56.35c.224.452.454.899.678 1.35"
    />
    <path
      stroke="#006CED"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.534}
      d="M213.777 43.867c1.403-.734 2.812-1.468 4.215-2.207"
    />
    <path
      stroke="#FF391F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.534}
      d="M125.397 46.378c-2.358.59-4.401 2.334-5.345 4.568s-.768 4.91.459 7.005c.512.872 1.243 1.675 2.214 1.962.97.282 2.187-.122 2.539-1.069.277-.734-.027-1.59-.587-2.138s-1.323-.835-2.091-1.005c-4.31-.962-11.08 3.697-12.707 11.478m39.583 9.94c4.188-4.99 10.306-8.324 16.777-9.143 2.593-.33 5.377-.223 7.591 1.154 2.214 1.383 3.574 4.362 2.443 6.707-.501 1.037-1.509 1.877-2.661 1.947-1.153.063-2.348-.809-2.428-1.958-.112-1.718 1.931-2.69 3.633-2.983 1.307-.224 2.678-.325 3.926.117 1.249.441 2.332 1.558 2.38 2.877M89.106 60.498c2.977.947 5.42 3.415 6.327 6.399m-80.088 61.801a15.01 15.01 0 0 0-1.755 10.754c.795 3.633 3.009 6.941 6.076 9.058"
    />
    <path
      stroke="#B0DFFF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={0.534}
      d="m156.04 154.583-10.216.011-6.828.006-39.706.032h-5.553l-62.788.053"
    />
  </svg>
);
